<script>
    import ButtonInput from "../atoms/ButtonInput.svelte";
    import EmailInput from "../atoms/EmailInput.svelte";
    import TextArea from "../atoms/TextArea.svelte";
    import TextInput from "../atoms/TextInput.svelte";

    export let valueTextInput;
    export let nameValue;
    export let email;
    export let valueTextArea;
    export let onClick;

</script>

<form>
    <div>
        <EmailInput bind:email={email} />
        <TextInput id="sujet" text="Sujet : " bind:value="{valueTextInput}" />
        <TextInput id="name" text="Nom : " bind:value="{nameValue}" />
        <TextArea id="mess" bind:value={valueTextArea} />
        <ButtonInput bind:onClick={onClick} value="Envoyer" />
    </div>
</form>

<style>
    form{
        display: flex;
        justify-content: center;
    }
    div{
        display: flex;
        flex-direction: column;
        width: 500px;
    }
</style>